export default __webpack_public_path__ + "static/media/Nike.612da0c7.svg";